'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosTelephoneOutline = function IoIosTelephoneOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.3 26.3c1.2 1.2 2 2.7 0 5.1-2 2.4-3.3 2.4-5 2.4-1.9 0-4.6-1.1-7.3-3.2-2.5-1.8-3.6-2.6-6.1-5.2-2.7-2.7-4.3-5-6.2-8.4-2.1-3.9-1.9-5.7-1.4-7.2 0.3-0.9 1.1-1.8 2.2-2.5l0.1-0.1c0.4-0.3 1.4-0.9 2.5-0.9 1 0 1.9 0.4 2.6 1.4l0.1 0c0.9 1.1 1.9 2.5 2.5 3.7 0.8 1.6 0.8 3-0.1 4.1-0.7 1-0.9 1.5-0.9 1.8s0.4 0.7 1 1.5l0.1 0c1.2 1.4 1.6 1.8 2 2.3 0.1 0.1 0.3 0.2 0.3 0.2l0.2 0.2c0.5 0.5 0.8 0.9 2.3 2.2l0 0.1c0.6 0.4 0.7 0.6 1 0.6 0.4 0 1.2-0.6 2.2-1.2 0.4-0.2 0.9-0.4 1.4-0.4 2.1 0 5.3 2.3 6.4 3.5z m-1 4.2c1.5-1.7 1-2.4 0.1-3.3-1-1.1-3.9-3.1-5.6-3.1-0.3 0-0.5 0.1-0.7 0.2-1.4 0.9-2.1 1.4-2.8 1.4s-1.2-0.5-1.8-1h-0.1c-1.5-1.3-1.8-1.7-2.4-2.3l-0.1-0.1c-0.1-0.1-0.3-0.2-0.3-0.3-0.5-0.4-0.9-0.9-2.1-2.3v-0.1c-0.8-0.8-1.4-1.4-1.5-2.2s0.4-1.5 1.3-2.6c1.2-1.6-0.4-3.8-2.4-6.2l-0.1-0.1c-0.5-0.6-1.1-0.9-1.7-0.9-0.8 0-1.4 0.4-1.8 0.7-0.1 0-0.2 0.1-0.2 0.1-0.8 0.5-1.4 1.2-1.6 1.8-0.4 1.3-0.6 2.8 1.3 6.2 1.8 3.3 3.4 5.5 6 8.1 2.4 2.5 3.5 3.3 5.9 5 2.5 1.8 5 3 6.6 3 1.6 0 2.5-0.1 4-2z' })
        )
    );
};

exports.default = IoIosTelephoneOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-telephone-outline.js
// module id = 2325
// module chunks = 0